<template>
  <Modal
    v-model="visible"
    title="注册"
    :loading="loading"
    :mask-closable="isClose"
    :closable="isClose">
      <div class="mgui-register" v-show="bindType!='login'" style="padding-right:20px">
        <Form ref="regForm" :model="regForm" :label-width="80" class="apps-login-form" :rules="ruleValidate">
          <FormItem label="姓名" prop="username">
            <Input type="text" placeholder="请输入真实姓名" v-model="regForm.username"></Input>
          </FormItem>
          <FormItem label="手机号码" prop="mobile">
            <Input type="text" placeholder="请输入手机号码" v-model="regForm.mobile"></Input>
          </FormItem>
          <FormItem label="项目部" prop="department_id" >
            <Cascader :data="$store.state.department" v-model="regForm.department_id" change-on-select></Cascader>
          </FormItem>
          <FormItem label="邮箱" prop="email">
            <Input type="text" placeholder="请输入email" v-model="regForm.email"></Input>
          </FormItem>
          <FormItem label="密码" prop="password">
            <Input type="password" placeholder="请输入密码" v-model="regForm.password"></Input>
          </FormItem>
          <FormItem label="确认密码" prop="confirm">
            <Input type="password" placeholder="请确认密码" v-model="regForm.confirm"></Input>
          </FormItem>
        </Form>
      </div>
      <div class="apps-qrcode" v-show="bindType=='login'" style="padding:0 20px">
        <Form ref="formInline" :model="formInline" label-position="top" class="apps-login-form" :rules="ruleInline">
          <FormItem label="手机号" prop="mobile">
            <Input class="input" type="text" size="large" name="mobile" v-model="formInline.mobile" @keyup.enter.native="bindUser('formInline')"></Input>
          </FormItem>
          <FormItem label="密码" prop="password">
            <Input class="input" type="password" size="large" name="password" v-model="formInline.password" @keyup.enter.native="bindUser('formInline')"></Input>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <!-- <span class="mgui-register-other">
          <a href="#login" @click="toLogin">返回登录</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="#login">忘记密码</a>
        </span> -->
        <div v-if="bindType!='login'">
          <span style="margin-right:20px">已有账号，点击 <a href="javascript:void(0)" @click.stop="bindType='login'">{{loginBtnTxt}}</a></span>
          <Button type="primary" :disabled="isDisabled" @click.prevent="registerSubmit('regForm')">
            注册并绑定微信
            <svg class="icon rotate" aria-hidden="true" v-show="isDisabled">
                <use xlink:href="#icon-loading"></use>
            </svg>
          </Button>
        </div>
        <div v-else-if="bindType=='login'">
            <span style="margin-right:20px">没有账号，点击 <a href="javascript:void(0)" @click.stop="bindType='register'">注册账号</a></span>
            <Button @click="bindUser('formInline')" type="primary" size="large">{{loginBtnTxt}}</Button>
        </div>
      </div>
    </Modal>
</template>

<script>
import {post} from '../fetch/api'
// import * as _ from '../util/tools'
import validate from '../util/validateForm'

export default {
  name: 'Register',
  props: {
    visible: {
      default: false
    }
  },
  data () {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入您的密码'))
      } else {
        if (this.regForm.confirm !== '') {
          // 对第二个密码框单独验证
          this.$refs.regForm.validateField('confirm')
        }
        callback()
      }
    }
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认您的密码'))
      } else if (value !== this.regForm.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    const checkPhone = (rule, value, callback) => {
      let res = validate.phone(value)
      if (res !== true) {
        callback(new Error(res))
      } else {
        callback()
      }
    }

    return {
      bindType: 'register',
      show: false,
      isDisabled: false,
      loading: false,
      loginBtnTxt: '绑定账号',
      regForm: {
        mobile: '',
        email: '',
        username: '',
        password: '',
        confirm: '',
        department_id: [12]
      },
      formInline: {
        mobile: '',
        password: ''
      },
      ruleInline: {
        mobile: [
          {required: true, message: '请输入手机号码', trigger: 'change'}
        ],
        password: [
          {required: true, message: '请输入登录密码', trigger: 'change'}
        ]
      },
      isClose: false,
      ruleValidate: {
        department_id: [
          {required: true, type: 'array', message: '请输选择', trigger: 'blur'}
        ],
        username: [
          {required: true, message: '请输入真实姓名', trigger: 'blur'}
        ],
        mobile: [
          {required: true, message: '请输入手机号码', trigger: 'blur'},
          {validator: checkPhone, trigger: 'blur'}
        ],
        email: [
          { required: true, message: '请输入Email', trigger: 'blur' },
          { type: 'email', message: 'Email格式错误', trigger: 'blur' }
        ],
        password: [
          { validator: validatePass, trigger: 'blur' }
        ],
        confirm: [
          { validator: validatePassCheck, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    visible: function (val) {
      console.log(val)
      if (val) {
        this.setBodyStyle()
        this.getDepartment()
      }
    }
  },
  mounted () {
    this.getDepartment()
    this.loginBtnTxt = '绑定账号'
    setTimeout(() => {
      if (!this.$store.state.logined && (process.env.NODE_ENV !== 'production' || this.$route.query.debug === 'true')) {
        this.loginBtnTxt = '登录'
        this.bindType = 'login'
        localStorage.removeItem('token')
      }
    }, 400)
  },
  methods: {
    getDepartment () {
      if (this.$store.state.department.length === 0) this.$store.dispatch('setDepartment', false)
    },
    registerSubmit (name) {
      this.isDisabled = true
      this.$refs[name].validate((valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.regForm))
          let openid = localStorage.getItem('openid')
          data['department_id'] = JSON.stringify(data['department_id'])
          if (openid) data['openid'] = openid
          // this.$store.dispatch('setLoadingState', true)
          post('auth/signup', data)
            .then(res => {
              if (res.status === 'ok') {
                this.$Message.success({
                  content: '注册成功，请等待审核！',
                  duration: 5
                })
                this.toLogin()
              }
            })
            .catch(res => {
              let msgs = res.error.errors
              for (let k in msgs) {
                let msg = msgs[k][0]
                this.$Message.error(msg)
              }
            })
        }
        setTimeout(() => {
          this.isDisabled = false
        }, 1000)
      })
    },
    toLogin () {
      this.$parent.loginModel = true
      this.$parent.regModel = false
    },
    regEnter () {
      this.show = this.$store.state.regState
    },
    regLeave () {
      this.show = false
    },
    setBodyStyle () {
      if (this.show) {
        document.body.setAttribute('style', 'overflow:hidden')
      } else {
        document.body.removeAttribute('style')
      }
    },
    bindUser (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.spinShow = true
          let data = this.formInline
          let openid = localStorage.getItem('openid')
          if (openid) data['openid'] = openid
          post(`/auth/login`, data)
            .then(res => {
              if (res.status === 'ok') {
                this.$store.dispatch('setToken', res.token)
                this.$Message.success('登录成功')
                this.spinShow = false
                // this.redirect()
              } else {
                this.spinShow = false
                this.$parent.loginModel = true
                this.$Message.error({
                  content: res.msg,
                  duration: 5
                })
              }
            })
            .catch(() => {
              this.$parent.spinShow = false
              // this.$parent.loginModel = true
              this.$Message.error('用户名或密码错误!')
            })
        } else {
          this.$Message.error('请输入用户名/密码！')
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .mgui-register .mgui-window-inner{
    width: 400px;
  }
  .mgui-register-other{
    font-size: 13px;
    line-height: 36px;
    color: #999;
    margin-right: 20px;
  }
  .mgui-register-other a{text-decoration: none;color:#333;}
</style>
